export class SaasTeamsChannelProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "teamId",
            "baseName": "teamId",
            "type": "string",
            "format": ""
        },
        {
            "name": "teamDisplayName",
            "baseName": "teamDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "membershipType",
            "baseName": "membershipType",
            "type": "string",
            "format": ""
        },
        {
            "name": "webUrl",
            "baseName": "webUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasTeamsChannelProperties.attributeTypeMap;
    }
    constructor() {
    }
}
